<template>
  <transition name="el-zoom-in-left"> 
  <!-- <transition name="el-fade-in-linear">  -->
  <div v-show="show" class="bigbox clearfix ">
    <div class="container" id="">
      <div class="top" id="">
       <!--  <button @click="tiao">
          跳转
        </button> -->
        <!-- search start -->
        <el-form :inline="true" class="demo-form-inline clearfix" style="width: 1166px">
          <el-form-item label="订单编号：" class="tinp">
            <el-input v-model="vbillcode" placeholder="请输入订单编号" suffix-icon="el-icon-search" clearable ></el-input>
          </el-form-item>
          <!-- <div> -->
              <el-form-item label="商品编码：" class="tinp">
                <el-input v-model="productCode" placeholder="请输入商品编码" suffix-icon="el-icon-search" clearable  ></el-input>
              </el-form-item>
              <el-form-item label="商品名称：" class="tinp">
                <el-input v-model="productName" placeholder="请输入商品名称" suffix-icon="el-icon-search" clearable  ></el-input>
              </el-form-item>
              <el-form-item label="请购月份：" class="tinp searchtime " style="width:264px">
              <el-date-picker value-format="yyyy-MM"  v-model="month"   type="month" placeholder="选择月"></el-date-picker>
              </el-form-item>
          <!-- </div> -->
          <!--  <el-form-item label="请购时间：" class="tinp searchtime" :class="{iconshow:showicon}">
           <el-date-picker  value-format="yyyy-MM-dd" v-model="time" type="date" placeholder="选择日期" @change="onParamChange"  @mouseover.native="cleandataicon" @mouseout.native="cleandataicon" >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="请购人：" class="tinp">
            <el-input v-model="creatorname" placeholder="请输入申请人" suffix-icon="el-icon-search" clearable @change="onParamChange"></el-input>
        </el-form-item> -->
          <el-button type="primary" class="" size="small" icon="el-icon-search" v-loading.fullscreen.lock="fullscreenLoading" @click="onParamChange">搜索</el-button>
          <!--  <el-button type="warning" style="margin-right: 20px" class="fr" size="small" v-loading.fullscreen.lock="fullscreenLoading" icon="el-icon-refresh" @click="shuaxin">刷新</el-button> -->
          <!-- search end -->
        </el-form>
      </div>
      <!-- :style="{'width': width}"  -->
      <div class="order-list-table" v-if="count >= 1">

        <table v-for="(data,index) in goodsList" v-if="data.productList.length>=1" class="downtablelist bigtablelist">
          <tr>
            <th :id="data.vbillcode" style="width:2rem;font-color:#56B8AA;background-color:#fff;position:relative" @click="showlist(data,index)">
              <i class="iconfont icon-jiantou_yemian_xiangshang jiantouxia" v-bind:class="{'jiantoushang':data.listshow =='N'}" style="color: #56B8AA;font-size: 22px;font-weight: 100;"></i>
            </th>
            <th class="allckeck" style="width:3rem" v-show="data.listshow =='N'">
              <div class="item-all-check">
                <span  class="checkbox-btn item-check-btn" v-bind:class="{'checked':data.allchecked=='Y'}" @click="toggleCheckAll(data,index)">
                   <span class="iconfont icon-duigou gou" style="font-size: 12px"></span>
                </span>
              </div>
            </th>
            <th colspan="9" class="thbox" style="padding:0 10px">
              <span class="toptitle fl">采购订单号：{{data.vbillcode}}</span>
              <span class="toptitle fl">供应商：{{data.supplierName}}</span>
              <span class="toptitle fl">快递公司：{{data.couriername}}</span>
              <span class="toptitle fl">快递单号：{{data.couriernumber}}</span>
              <span class="toptitle fl">发货日期：{{data.arrivalTime}}</span>
              <!-- <span class="toptitle fl">到货单号：{{data.arrivalCode}}</span> -->
              <!-- <span class="toptitle fl" style="margin-left: 1rem">{{data.creationtime}}</span> -->
              <!-- <span class="toptitle fl">审核人：{{data.approvername}}</span> -->
              <!-- <span class="toptitle fl">单据状态：{{data.fbillstatus}}</span> -->
              <!-- <span class="toptitle fr">采购总数：{{data.ntotalastnum}}</span> -->
              <!-- <span class="toptitle fr">合计：{{data.ntotalorigmny|currency('￥')}}</span> -->
              <!-- <span class="toptitle fr">采购人：{{data.billmakername}}</span> -->
              <!-- <span class="toptitle fr" v-if="data.modifiername!=''&&data.modifiername!=null">最后修改人：{{data.modifiername}}</span> -->
            </th>
          </tr>
          <!-- <el-collapse-transition> -->
          <tr class="first noimg" v-show="data.listshow =='N'">
            <td bgcolor="#EFF0F4" style="border: 1px solid #EFF0F4"></td>
            <td class="fir" style="color: #fff;"></td>
            <td style="width:12%" class="tdtitle">到货单行号</td>
            <td style="width:12%" class="tdtitle">商品编码</td>
            <td style="width:18%" class="tdtitle">商品名称</td>
            <td style="width:8%" class="tdtitle">供方发货数</td>
            <!-- <td style="width:8%">单价</td> -->
            <td style="width:16%" class="tdtitle">规格</td>
            <td style="width:16%" class="tdtitle">型号</td>
            <td style="width:110px;text-align: center;padding-right: 20px !important" class="lastbut tdtitle">
              操作
            </td>
          </tr>
          <tr v-for="(item,index2) in data.productList" class="first noimg" v-show="data.listshow =='N'">
            <td bgcolor="#EFF0F4" style="border: 1px solid #EFF0F4"></td>
            <td class="fir" style="color: #fff;">
              <div class="list-item-check">
                <span class="checkbox-btn item-check-btn" v-bind:class="{'checked':item.checked=='1'}" @click="choose(item,data,index,index2)">
                <span class="iconfont icon-duigou" style="font-size: 12px"></span>
                </span>
              </div>
              <!-- <el-checkbox v-model="item.checked"  @click="choose(item,data,index)"></el-checkbox> -->
            </td>
            <!-- <td style="width:11%"><img class="titleimg" v-lazy="'../../static/img/'+item.prodcutImg" alt="" /></td> -->
            <td style="width:12%">{{ item.crowno }}</td>
            <td style="width:12%">{{ item.vvendinventorycode }}</td>
            <td style="width:18%">{{ item.vvendinventoryname }}</td>
            <td style="width:8%">{{ item.nqnum }}</td>
            <!-- <td style="width:8%">{{ item.nqtorigtaxprice|currency('￥') }}</td> -->
            <!-- <td style="width:8%">{{ item.norigtaxmny|currency('￥') }}</td> -->
            <td style="width:16%">规格：{{ item.wlspec }}</td>
            <td style="width:16%">型号：{{ item.wltype }}</td>
            <td style="width:110px;text-align: center;padding-right: 20px !important" class="lastbut">
             <el-button type="primary" class="" size="small" @click="handleSubmit(index,index2)" v-if="index2==0">确认收货</el-button>
            </td>
          </tr>
        </table> 

      </div>
      <div class="msgNone" v-else style="text-align: center;font-size: 15px;color: #333;margin-top: 20px">
        <span>暂无数据</span>
      </div>
      <!-- fenye start -->
      <div class="block" style="text-align: center;margin:20px auto ">
        <span>
          <el-pagination class="fenye" @size-change="handleSizeChange" @current-change="handleCurrentChange"  background
            :current-page="page"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="count">
          </el-pagination>
          </span>
      </div>
      <!-- fenye end -->
    </div>
    <!-- <Modal :shouShow='shouShow'></Modal> -->
    <div class="model" v-show="shouShow">
      <div class="content">
        <div class="title">
          <span class="fl">添加收货明细</span>
          <span class="fr" @click="closemodel(1)"><i class="iconfont icon-guanbi"></i></span>
        </div>
        <div class="tablebox shou clearfix" style="width:1100px;margin:10px auto 0;">
          <div style="width:100%">
            <table style="width:100%;margin:0">
              <tr style="height: 45px;">
                <!-- <th class="tdwidth" style="width:140px">商品编码</th> -->
                <th class="tdwidth" style="width:80px">到货单行号</th>
                <th class="tdwidth" style="width:200px">商品名称</th>
                <th class="tdwidth" style="width:100px">商品编码</th>
                <!-- <th class="tdwidth" style="width:166px">仓库</th>  -->
                <th class="tdwidth" style="width:110px">货位</th> 
                <th class="tdwidth" style="width:80px">采购订单数</th>
                <th class="tdwidth" style="width:80px">供方发货数</th>
                <th class="tdwidth" style="width:80px">历史入库数</th>
                <th class="tdwidth" style="width:80px">当前入库数</th>
                <th class="tdwidth" style="width:320px">备注</th>
                <th class="tdwidth" style="width:80px">操作</th>
              </tr>
            </table>
            <div style="overflow-y: auto;overflow-x:hidden;height: auto;width:100%;max-height:206px">
              <table style="margin:0;width:100%">
                <tr v-for="(item,index) in tableData.productList" :key="item.crowno" v-if="item.checked == '1'">
                 <!--  <td class="tdwidth pronamewidth" style="width:140px"> 
                    <span>{{item.vvendinventorycode}}</span>
                  </td> -->
                  <td class="tdwidth pronamewidth" style="width:80px">
                    <span>{{item.crowno}}</span>
                    <!-- <span>{{item.vvendinventoryname}}</span> -->
                  </td>
                  <td class="tdwidth pronamewidth" style="width:200px">
                    <input class="tabinp" disabled="disabled" v-model="item.vvendinventoryname"></input>
                    <!-- <span>{{item.vvendinventoryname}}</span> -->
                  </td> 
                  <td class="tdwidth pronamewidth" style="width:100px">
                    <input class="tabinp" disabled="disabled" v-model="item.vvendinventorycode"></input>
                    <!-- <span>{{item.vvendinventoryname}}</span> -->
                  </td>
                  <!--  <td class="tdwidth" style="width:164px"> 
                         <span>{{item.repertoryname}}</span>
                    </td> -->
                   <td class="tdwidth" style="width:120px"> 
                        <el-input @paste.native.capture.prevent="inpFlag" @oncut.native.capture.prevent="inpFlag" @ondragenter.native.capture.prevent="inpFlag" v-model="item.positionname" suffix-icon="el-icon-search" v-on:click.native="openselectmodel(index)"></el-input>
                         <!-- <span>{{item.positionname}}</span> -->
                    </td>
                  <td class="tdwidth" style="width:80px">
                    <span>{{item.nnum}}</span>
                  </td>
                  <td class="tdwidth" style="width:80px">
                    <span>{{item.nqnum}}</span>
                  </td>
                  <td class="tdwidth" style="width:80px">
                    <span>{{item.naccumstorenum == null?0:item.naccumstorenum}}</span>
                  </td>
                  <td class="tdwidth" style="width:80px" @paste.native.capture.prevent="inpFlag" @ondragenter.native.capture.prevent="inpFlag">
                    <el-input class="tabinp" v-model="item.nsnum" @blur="numdown(item.nqnum,item.naccumstorenum,item.nsnum)" type="number" clearable></el-input>
                  </td>
                  <td class="tdwidth" style="width:320px" @paste.native.capture.prevent="inpFlag" @ondragenter.native.capture.prevent="inpFlag">
                    <el-input class="tabinp" v-model="item.vbmemo" clearable></el-input>
                  </td>
                  <td style="border: 1px solid #56B8AA;width:80px">
                    <el-button type="warning" class="" size="small" @click="dellist(index)">取消</el-button>
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <el-button type="primary" class="fr" @click="sumbittable" style="margin-top: 20px;">确认提交</el-button>
        </div>
      </div>
    </div>
    <!-- model start -->
    <div class="model selectmodel" v-show="modelShow">
      <div class="content">
        <div class="title">
          <span class="fl">选择货位</span>
          <span class="fr" @click="closemodel(2)"><i class="iconfont icon-guanbi"></i></span>
        </div>
        <div class="selectinput">
          <el-form :inline="true" style="padding:10px">
            <el-form-item class="" style="width:100%;margin: 0 !important">
              <el-select @change="selectchange" filterable value-key="positioncode" v-model="position.positionname" clearable placeholder="请选择货位" style="width:100%;" auto-complete="off">
                <el-option v-for="item in positionList" :key="item.positioncode" :label="item.positionname" :value="item"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <!-- model end -->
    <!-- model start -->
    <div class="" v-show="fullscreenLoading" ></div>
    <!-- model end -->
    <!--  <el-button type="info" v-show="showTop" icon="el-icon-arrow-up" circle id="to-top-btn" style="position:fixed;right:16px;bottom:20px;" @click="toTop"></el-button> -->
    <!-- 弹窗 start -->
    <MessageModel types="提示信息" :msg="msg" :msgShow="msgShow" :flag="modelFlag" :butmsg="butmsg" :butflag = "butflag" @modelmsg="returnMsg"></MessageModel>  
  </div>
  </transition> 
</template>
<style>
</style>
<script>
import { currency } from '../../utils/currency' 
import axios from 'axios'

export default {
  inject: ['reload'], 
  data() {
    return {
      inject:['reload'],
      flag:false,
      show:true,
      msgShow:false,
      modelFlag:false,
      modelFlag2:false,
      butflag:true,
      butflag2:true,
      msg:'', 
      butmsg:'确认', 
      butmsg2:'确认', 
      methodName:'',
      utilpath: '',
      fullscreenLoading: false,
      inpFlag: true,
      shouindex:'',
      productName:'',
      productCode:'',
      month:'',
      showicon: '',
      index1: '',
      width: '',
      InterfacePath: '',
      users: '',
      shoubutindex: 0,
      widthdata: 0,
      shouShow: false,
      modelShow: false,
      query: '',
      page: 1,
      pagesize: 10,
      count: 0,
      busy: true,
      loading: false,
      vbillcode: '',
      time: '',
      creatorname: '',
      id: '',
      goodsList: [

      ],
      tableData: [],
      orderList: [],
      shouhuoList: {},
      allprice: '',
      modalConfirm: false,
      tableListindex: 0,
      position: {
        positioncode: '', //货位编码
        positionname: '', //货位名称
      },
      positionList: [],
      tableHeads: [{
          label: '收货仓库',
          key: 'repertoryname'
        },
        {
          label: '收货货位',
          key: 'positionname'
        },
        // {
        //   label: '商品名称',
        //   key: 'vvendinventoryname'
        // },
        {
          label: '采购数量',
          key: 'nnum'
        },
        {
          label: '发货数量',
          key: 'nqnum'
        },
        {
          label: '入库数量',
          key: 'nqnum'
        },
        {
          label: '实收数量',
          key: 'nsnum'
        },
        // {
        //   label: '收货人',
        //   key: 'receivename'
        // },
        {
          label: '备注',
          key: 'memo'
        }
      ],
      model1: '',
      index: '',
      loading: true,
      showTop: false,
      quxiaoindex:'',
      step: 0
    }
  },
  components: {

  },
  watch: {
    query() {
      this.getList();
    }
  },
  mounted() {
    // 获取接口名
    this.InterfacePath = window.localStorage.getItem("InterfacePath");
    this.utilpath = this.axios.defaults.baseURL;
    this.users = JSON.parse(window.localStorage.getItem("userInfo"));
    // console.log("打印users:"+JSON.stringify(this.users));
     if(this.users==null){
        this.$router.push({
          path: '/ui/login',query:{msg:-1}
        }); 
        this.fullscreenLoading =  false;
     }else{
        this.init();
     }
  },
  filters: {
    currency: currency
  },
  computed: {

  },
  destroyed() {
    sessionStorage.removeItem("shouShow");
    sessionStorage.removeItem("tableData");
    sessionStorage.removeItem("vbillcode");
    // sessionStorage.removeItem("query");
    sessionStorage.removeItem("shouList");
    this.show = false;
  },
  methods: {
    tiao(){
     window.open('https://www.baidu.com', '_blank');
    },
    returnMsg(flag){ 
      this.modelFlag = false;
      if(flag){
            if(this.methodName =='---'){
                var reqparams={
                  storecode:this.users.storecode,
                  productCode:this.productCode
                }
                this.$http.post(this.utilpath+'/delettePrabillB',reqparams,{emulateJSON:true,_timeout:600}).then((res)=>{ 
                    if(res.data.status == '0'){
                        
                    } else if(res.data.status == '9'){
                            this.$router.push({path:'/ui/login',query:{msg:9}});
                    } else{
                      this.modelFlag = true;
                      this.methodName = 'message';
                      this.msg = res.data.message;
                      this.butflag =false;
                      this.butmsg='知道了'; 
                    }
                }, (err) => {
                  this.modelFlag = true;
                  this.methodName = 'message';
                  this.msg = '获取接口失败'+err;
                  this.butflag =false;
                  this.butmsg='知道了'; 
                })
            }else if(this.methodName =='取消收货'){
              if (this.tableData.productList.length > 1) {
                this.tableData.productList.splice(this.quxiaoindex,1);
                // this.tableData.productList[this.quxiaoindex].checked = '0'
              }else{
                this.$message({
                    showClose:true,
                    message:'收货商品不能再少了！',
                    type:'info'
                })
              } 
            }else if(this.methodName =='tijiaotable'){ 
                this.fullscreenLoading = true; 
                var pram = {
                  poorder: JSON.stringify(this.tableData),
                  storecode: this.users.storecode,
                  naccumarrvnum: 0,
                  fbillstatus: '4',
                  vbillcode: this.vbillcode, //请购单号
                  creatorname: this.creatorname, //请购人
                  time: this.time, //请购时间
                  pageNum: this.page, //当前页
                  pageSize: this.pagesize //页面数据条数
                }

                // console.log("_+_+_+___+_+_+_+_+__+：" + JSON.stringify(this.tableData));
                //获取数据接口 
                // this.$post("/confirmPoOrder",pram,{emulateJSON:true}).then((res) => {
                this.$http.post(this.utilpath + '/confirmPoOrder', pram, { emulateJSON: true,_timeout:600 }).then((res) => {
                  // console.log("收货后数据："+JSON.stringify(res.data));
                  // this.$http.post("/ktnapi/confirmPoOrder",pram,{emulateJSON:true}).then((res) => {
                  // this.$http.post(this.InterfacePath+"/confirmPoOrder",pram,{emulateJSON:true}).then((res) => { 
                  if (res.data.status == '0') {
                    this.fullscreenLoading = false; 
                    this.$message({
                      showClose: true,
                      message: '收货成功！',
                      type: 'succcess'
                    });
                    this.goodsList = res.data.resultList;
                    this.count = res.data.countNum;
                    this.shouShow = false;
                    sessionStorage.removeItem("shouShow");
                  } else if(res.data.status == '9'){
                    this.fullscreenLoading =false;
                          this.$router.push({path:'/ui/login',query:{msg:9}});
                  } else {
                    this.fullscreenLoading = false;
                    this.modelFlag = true;
                    this.msgShow = true;
                    this.methodName = 'message';
                    this.msg = res.data.message;
                    this.butflag =false;
                    this.butmsg='知道了'; 
                  }
                }, (err) => {
                  this.fullscreenLoading = false;
                  this.modelFlag = true;
                  this.msgShow = false;
                  this.methodName = 'message';
                  this.msg = '获取提交采购收货接口失败';
                  this.butflag =false;
                  this.butmsg='知道了'; 
                });
            }
      }else{
        this.$message({
          showClose:true,
          message:'已取消',
          type:'succcess'
        })
      }
    },  
    numdown(num1,num2,num){
      // console.log("进来判断了");
        if(num<0){
              this.$message({
                showClose: true,
                message: '收货数量不能为负数！',
                type: 'error'
              });
        }else if(num1-num2 < num){
              this.$message({
                showClose: true,
                message: '收货数量超出发货数量！',
                type: 'error'
              });
        }


    },
    shuaxin() {
      // console.log("-=-=--=-=-=-=-=刷新前");
      this.reload();
      // console.log("-=-=-=-=-=--=--=-=-=--=刷新后");
    },
    cleandataicon() {
      // console.log("划过");
      // console.log("打印时间-=-=-=-" + this.time);
      if (this.time != '') {
        // console.log("打印时间-=-=-=-" + this.time);
        this.showicon = !this.showicon;
      }
      if (this.time == null) {
        this.showicon = false;
      }
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.pagesize = val;
      this.page=1; 
      this.getList();
      console.log(this.pagesize);
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.page = val;
      // console.log(this.page);
      this.getList();
    },
    dellist(index) { //删除数据 
        this.quxiaoindex=index;
        this.methodName = '取消收货';
        this.modelFlag = true;
        this.butflag = true;
        this.msgShow = false;
        this.butmsg='确认';
        this.msg = '此操作将此商品剔除收货列表，是否继续？' 
    },
    scrollEvent(e) {
      // this.scrollToTop();
      this.showTop = e.srcElement.scrollTop > 800 ? true : false;
      //滚动的像素+容器的高度>可滚动的总高度-20像素
      // console.log("触发滚动事件");
      if (e.srcElement.scrollTop + e.srcElement.offsetHeight > e.srcElement.scrollHeight - 20 && this.loading) {
        this.getList(true); //加载更多
      }
    },
    toTop() {
      var idmsg = '';
      if (this.id != '') {
        idmsg = this.id;
      } else {
        idmsg = 'contain';
      }
      //参数i表示间隔的幅度大小，以此来控制速度
      var dis = (document.getElementById(idmsg).scrollTop) / 8
      this.step = dis;
      document.getElementById(idmsg).scrollTop -= dis;
      var scroll = document.getElementById(idmsg).scrollTop;
      if (scroll > 0) {
        // console.log("回到顶部循环内" + document.getElementById(idmsg).scrollTop);
        this.step += dis
        var c = setTimeout(() => this.toTop(this.step), 16);
      } else {
        clearTimeout(c);
      }
    },
    //显示隐藏表格
    showlist(item, index) {
      // console.log("展开方法");
      // 取反(true或false)
       this.goodsList[index].listshow = item.listshow == 'Y' ? 'N' : 'Y'; 
        this.index1 = index;
        this.id = item.vbillcode;
        this.toTop(); 
    },
    getpositions() {
      //获取数据接口
      var reqParam = {
        storecode: this.users.storecode,
        flag: '0'
      };
      this.$http.post(this.utilpath + '/selectStorespositioninfo', reqParam, { emulateJSON: true,_timeout:600 }).then((res) => {
        // this.$http.post('/ktnapi/selectStorespositioninfo',reqParam,{emulateJSON:true}).then((res) => {
        //this.$post('/selectStorespositioninfo',reqParam,{emulateJSON:true}).then((res) => {
        // this.$http.post(this.InterfacePath+'/selectStorespositioninfo',reqParam,{emulateJSON:true}).then((res) => {
        if (res.data.status == '0') {
          var positions = res.data.resultList;
          //var positions=res.data.result;
          this.positionList = [];
          for (var i = positions.length - 1; i > -1; i--) {
            this.positionList.push({ positionname: positions[i].positionname, positioncode: positions[i].positioncode });
          }
          // console.log("打印货位" + JSON.stringify(this.positionList));
        } else if(res.data.status == '9'){
          this.fullscreenLoading =false;
                this.$router.push({path:'/ui/login',query:{msg:9}});
        } else {
          this.modelFlag = true;
          this.msgShow = true;
          this.methodName = 'message';
          this.msg = res.data.message;
          this.butflag =false;
          this.butmsg='知道了'; 
        } 
      }, (err) => {
          this.modelFlag = true;
          this.msgShow = false;
          this.methodName = 'message';
          this.msg = '调取货位接口失败';
          this.butflag =false;
          this.butmsg='知道了'; 
      });
    },
    getposition() {
      //获取数据接口
      var reqParam = {
        storecode: this.users.storecode
      };
      this.$http.post(this.utilpath + '/selectStorespositioninfo', reqParam, { emulateJSON: true,_timeout:600 }).then((res) => {
        // this.$http.post('/ktnapi/selectStorespositioninfo',reqParam,{emulateJSON:true}).then((res) => {
        //this.$post('/selectStorespositioninfo',reqParam,{emulateJSON:true}).then((res) => {
        // this.$http.post(this.InterfacePath+'/selectStorespositioninfo',reqParam,{emulateJSON:true}).then((res) => {
        if (res.data.status == '0') {
          var positions = res.data.resultList;
          //var positions=res.data.result;
          this.positionList = [];
          for (var i = positions.length - 1; i > -1; i--) {
            this.positionList.push({ positionname: positions[i].positionname, positioncode: positions[i].positioncode });
          }
          // console.log("打印货位" + JSON.stringify(this.positionList));
        } else if(res.data.status == '9'){
                this.$router.push({path:'/ui/login',query:{msg:9}});
        } else {
            this.modelFlag = true;
            this.msgShow = true;
            this.methodName = 'message';
            this.msg = res.data.message;
            this.butflag =false;
            this.butmsg='知道了'; 
        }       
      }, (err) => {
        this.modelFlag = true;
        this.msgShow = false;
        this.methodName = 'message';
        this.msg = '获取货位接口失败';
        this.butflag =false;
        this.butmsg='知道了'; 
      });
    },
    selectchange(value) {
      // console.log("下拉变化事件1" + JSON.stringify(value) + "下标：");
      // console.log("下拉变化事件2" + value.positioncode);
      this.tableData.productList[this.tableListindex].positioncode = value.positioncode;
      this.tableData.productList[this.tableListindex].positionname = value.positionname;
   
      sessionStorage.setItem("tableData", JSON.stringify(this.tableData));
      this.modelShow = false;
      this.position = {
        positioncode: '',
        positionname: ''
      };
    },
    //确认提交收货单
    sumbittable() {
      // console.log(this.tableData.productList.length+"收货数据："+JSON.stringify(this.tableData.productList));
      var flag = true;
      var flag2 = false;
      var flag3 = false;
      // this.goodsList[this.index].productList.forEach((item) => {
      this.tableData.productList.forEach((item) => {
        // console.log("========================"+item.positionname);
        if (item.checked == '1' && item.nsnum === '') {
          // console.log("-=-=-=-=-=-=-=-" + item.nsnum);
          flag = false;
          return;
        }
        if(item.nsnum<0){
            flag2 = true; 
        }
        if(item.nqnum-item.naccumstorenum<item.nsnum){
            flag3 = true; 
        }
      });
      if (!flag&&!flag2&&!flag3) {
        this.$message({
          showClose: true,
          message: '请将明细表填写完整！',
          type: 'error'
        });
      } else if(flag2){
           this.$message({
                showClose: true,
                message: '收货数量不能为负数！',
                type: 'error'
           });
      }else if(flag3){
           this.$message({
                showClose: true,
                message: '收货数量不能大于发货数量！',
                type: 'error'
           });
      }else {
        this.methodName = 'tijiaotable';
        this.modelFlag = true;
        this.msgShow = false;
        this.butflag = true;
        this.butmsg='确认';
        this.msg = '确定提交收货单？';
      }
    },
    openselectmodel(index) {
      // console.log("model内打印：" + index);
      this.tableListindex = index;
      this.modelShow = true;
    },
    //关闭弹窗
    closemodel(num) {
      if (num == 1) {
        sessionStorage.removeItem("shouShow");
        this.shouShow = false;
        this.tableData = [];
        // this.reload();  
      } else {
        sessionStorage.removeItem("modelShow");
        this.modelShow = false;
      }
    },
    //获取数据
    getList() {
      // path = 'api/goods'
      this.fullscreenLoading = true;
      // console.log("打印月份："+this.month);
      var reqParams = {
        storecode: this.users.storecode,
        // naccumarrvnum: 0,
        // fbillstatus: '3',
        forderstatus: '3', //单据状态
        vbillcode: this.vbillcode, //请购单号  
        productName:this.productName,//商品名称
        productCode:this.productCode,//商品编码
        month:this.month,
        pageNum: this.page, //当前页
        pageSize: this.pagesize //页面数据条数
      }
      //获取数据接口
      // console.log("打印参数：" + JSON.stringify(reqParams));
       // if(this.users.user_code =='cfx'){
       //        this.utilpath = 'http://192.168.0.109:8082/ktn'
       //    }
      this.$http.post(this.utilpath + '/selectPoOrderInfo', reqParams, { emulateJSON: true,_timeout:600 }).then((res) => {
        // this.$http.post('/ktnapi/selectPoOrderInfo', reqParams,{emulateJSON:true}).then((res) => {
        // this.$post('/selectPoOrderInfo', reqParams,{emulateJSON:true}).then((res) => {
        // this.$http.post(this.InterfacePath+'/selectPoOrderInfo', reqParams,{emulateJSON:true}).then((res) => { 
        if (res.data.status == '0') {
          this.fullscreenLoading = false;
          this.goodsList = res.data.resultList;
          this.count = res.data.countNum;
        } else if (res.data.status == '-1') {
          this.goodsList = [];
          this.fullscreenLoading = false;
          this.$message({
            showClose: true,
            message: '暂无数据！',
            type: 'info'
          });
          this.count = res.data.countNum;
        } else if(res.data.status == '9'){
          this.fullscreenLoading =false;
                this.$router.push({path:'/ui/login',query:{msg:9}});
        } else {
          this.fullscreenLoading = false; 
          this.modelFlag = true;
          this.msgShow = true;
          this.methodName = 'message';
          this.msg = res.data.message;
          this.butflag =false;
          this.butmsg='知道了'; 
        }      
      }, (err) => {
        this.fullscreenLoading = false;
        this.modelFlag = true;
        this.msgShow = false;
        this.methodName = 'message';
        this.msg = '获取采购收货数据接口失败';
        this.butflag =false;
        this.butmsg='知道了'; 
      });
    },
    //初始化
    init() {
      this.width = document.documentElement.clientWidth - 220;
      // console.log("打印-=-==-==-宽度" + this.width);
      // this.users = JSON.parse(window.localStorage.getItem("userInfo"));
      // this.widthdata = document.documentElement.clientWidth - 254;
      // document.getElementById("top").setAttribute("width",this.widthdata+'px');
      // document.getElementById("top").style.width = this.widthdata+'px';
      // console.log("初始宽" + this.widthdata);
      var goods = JSON.parse(sessionStorage.getItem("shouList"));
      if (goods == null) {
        this.getposition();
        // this.getList();
      } else {
        this.fullscreenLoading =false; 
        // console.log("打印session获取的goods" + sessionStorage.getItem("shouList"));
        this.goodsList = goods;
        this.vbillcode = sessionStorage.getItem("vbillcode");
        // this.query = sessionStorage.getItem("query");
      }
      var Show1 = sessionStorage.getItem("shouShow");
      var list = JSON.parse(sessionStorage.getItem("tableData"));
      if (Show1 == null) {
        this.shouShow = false;
      } else {
        this.shouShow = Show1;
        list.forEach((item) => {
          this.tableData = [];
          this.tableData.push(item);
        });
      }
      // console.log("打印刷新数据" + JSON.stringify(this.tableData));
    },
    //收货弹窗显示
    handleSubmit(index,index2) {
      // console.log(index+"------111---------"+index2)
      this.shouindex = index2;
      var checkedNum = 0;
      this.goodsList[index].productList.forEach((item) => {
          if (item.checked == '1') {
          ++checkedNum
        }
      });
      // console.log("1111"+checkedNum)
      if(checkedNum == 0){
         this.methodName ='method1'
         this.modelFlag = true;
         this.msgShow = false;
         this.msg = '请至少选择一件商品！';
         this.butflag = false;
         this.butmsg = '知道了';
         // console.log("2222222222"+this.butmsg)
      }else{ 
          this.index = index;
          // console.log("打印下标：" + index);
          // console.log("11111打印收货数据：" + JSON.stringify(this.goodsList[index]));
          this.tableData = {};
          var tablebox={}
          var shou = this.goodsList[index];
          tablebox = JSON.parse(JSON.stringify(shou));
          tablebox.productList = [];
          // console.log("11111打印收货数据：" + JSON.stringify(this.goodsList[index])); 
          var num = 0;
          var num2 = 0;
          this.goodsList[index].productList.forEach((item) => {
            this.goodsList[index].productList[num].repertorycode = this.users.storehouse_code;
            this.goodsList[index].productList[num].repertoryname = this.users.storehouse_name;
            // console.log("-------------------" + JSON.stringify(item) + "-------------------"); 
            if(item.checked=='1'){

              tablebox.productList.push(item); 
            } 
            ++num;
          })
          this.tableData = JSON.parse(JSON.stringify(tablebox));
          // console.log(this.tableData.productList.length+"this.tableData------------" + JSON.stringify(this.tableData.productList) + "====================this.tableData");
           
          if (num < 5) {
            this.height = (50 + (42 * num));
          } else {
            this.height = (50 + (42 * 5));
          }
          this.getposition();

          //console.log("------------------content------------------"+document.getElementById("cont").offsetWidth)
          // document.getElementById("table2").style.width = document.getElementById("table1").offsetWidth+'px';
          this.shouShow = true;
          sessionStorage.setItem("shouShow", true);
          sessionStorage.removeItem("tableData");
          sessionStorage.setItem("tableData", JSON.stringify(this.tableData));
          //document.getElementById("position_name1").style.width ='14%';
          //document.getElementById("position_name2").style.width ='14%';
      }
    },
    //搜索框变化事件
    onParamChange() {
      sessionStorage.setItem("vbillcode", this.vbillcode);
      this.page=1;
      // sessionStorage.setItem("query",this.query);
      this.getList();
      // document.getElementById("contain").scrollTop = 0;
      sessionStorage.removeItem("shouList");
      sessionStorage.setItem("shouList", JSON.stringify(this.goodsList));
      // console.log('月变化');
      // console.log('打印月'+this.month);
    },
    // 单选点击事件
    choose(item, data, index,index2) {
      item.checked = item.checked == "1" ? '0' : '1';
       var dataFlag = 'Y';
      data.productList.forEach((item) => {
        if (item.checked != '1') {
          dataFlag= 'N';
          return;
        }
      });
      data.allchecked = dataFlag;
      var money = 0;
      data.productList.forEach((item2) => {
        if (item2.checked == '1') {
          money += parseFloat(item2.ntaxmny);
        };
      });
      this.goodsList[index].ntotaltaxmny = money;
      // console.log("打印参数index"+index2);
    },
    // 全选点击事件
    toggleCheckAll(data, index) {
      // console.log("data" + data.productList);
      data.allchecked = data.allchecked == 'N' ? 'Y' : 'N';

      data.productList.forEach((item) => {
        item.checked = data.allchecked == 'Y' ? '1' : '0';
        // console.log(item.checked + "-=-=-=-=打印选中状态-=-=-==");
      });
      var money = 0;
      data.productList.forEach((item2) => {
        if (item2.checked == '1') {
          money += parseFloat(item2.ntaxmny);
        };
      });
      this.goodsList[index].ntotaltaxmny = money;
      // console.log(data.allchecked + "-=-=-=-=打印选中状态-=-=-==");
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/views/receives/qinggou.vue